import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { StatementList, Params } from 'app/dataTypes/cafeteria/compensation/statements'

import {
  GET_COMPENSATION_WITHDRAW_ORDERS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/get'


type Options = {
  params: Params
  autoload?: boolean
}

const defaultOptions = {
  autoload: true,
}

const defaultState: StatementList = []

export function useCompensationStatements(options: Options) {
  const { autoload, params } = { ...defaultOptions, ...options }
  const { studentID, supplierID, dateFrom, dateTo } = params

  const [statements, setStatements] = useState(defaultState)
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_COMPENSATION_WITHDRAW_ORDERS, {
      error: 'Не удалось получить данные заявок на вывод компенсации',
      params: {
        studentID,
        supplierID,
        dateFrom,
        dateTo,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)

    if (res) {
      setStatements(res)
    }
  }, [studentID, supplierID, dateFrom, dateTo])

  useEffect(() => {
    if (autoload) {
      request()
    }
  }, [request, autoload])

  return {
    statements,
    loading,
    request,
  }
}
